export const INTERNAL_UTILS_ROUTE = '/internal-utils';
export const INTERNAL_ALLOWLIST_ROUTE = '/internal-utils/allowlist';

/**
 * WIP on `FUTURES_ROUTE`:
 *  After we rename `/perpetuals` route to be `/futures`
 *  we also need to rename all the `perpetuals` references in code (file, folder, variable names)
 *  open separate PR to `rename-all` when we have enough test coverage
 */
export const FUTURES_ROUTE = '/futures';
export const FUTURES_SYMBOL_SEGMENT = ':symbol';
export const FUTURES_SYMBOL_ROUTE = `/futures/${FUTURES_SYMBOL_SEGMENT}`;

export const OPTIONS_ROUTE = '/options';
export const OPTIONS_ASSET_SEGMENT = ':asset';
export const OPTIONS_EXPIRY_DATE_SEGMENT = ':expiryDate';
export const OPTIONS_ASSET_ROUTE = `/options/${OPTIONS_ASSET_SEGMENT}`;
export const OPTIONS_ASSET_EXPIRY_ROUTE = `/options/${OPTIONS_ASSET_SEGMENT}/${OPTIONS_EXPIRY_DATE_SEGMENT}`;

export const PORTFOLIO_ROUTE = '/portfolio';
export const STATUS_ROUTE = '/status';

export type FuturesRouteParams = {
  symbol?: string;
};

export type OptionsRouteParams = {
  asset: string;
  expiryDate: string;
};
